/**
 * Refuse to APPLY a workspace snapshot read from disk while some of its files
 * cannot be read (git sync Stage 1, cards 3 + 4: "a malformed file is
 * reported and skipped — never deletes data"; "a half-written file is not
 * applied").
 *
 * Applying is a full diff: an entity whose file did not load counts as
 * deleted. So one broken request YAML (a typo, or VS Code saving mid-edit)
 * would delete that request from Apiboo. Instead nothing is applied, the user
 * is told which files, and the next save of a fixed file applies everything.
 */
import { useNotificationStore } from '../store/notificationStore';

let lastReported = '';

/** True when `snap` must not be applied; reports the files (once per distinct list). */
export function blockedByUnreadable(snap) {
  const files = Array.isArray(snap?.unreadableFiles) ? snap.unreadableFiles : [];
  if (files.length === 0) {
    lastReported = '';
    return false;
  }
  const key = files.join('\n');
  if (key !== lastReported) {
    lastReported = key;
    const shown = files.slice(0, 3).join(', ') + (files.length > 3 ? ` and ${files.length - 3} more` : '');
    useNotificationStore
      .getState()
      .warning(
        `Apiboo could not read ${files.length === 1 ? 'a workspace file' : `${files.length} workspace files`}: ${shown}. Nothing was changed — fix the file and save it again.`,
        'Workspace files not applied'
      );
  }
  return true;
}

/** Tests only. */
export function __resetUnreadableForTests() {
  lastReported = '';
}
